import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
const projects = [{
  region: "Norseman · WA",
  title: "Norseman Gold Project",
  service: "Mining services",
  client: "For Pantoro"
}, {
  region: "Kalgoorlie · WA",
  title: "KCGM Operations",
  service: "Mining services",
  client: "For Northern Star"
}, {
  region: "Mid-West · WA",
  title: "Mt Magnet & Cue",
  service: "Full mining services",
  client: "For Ramelius Resources"
}];
export function ProjectExperience() {
  return <section id="work" aria-labelledby="work-heading" className="bg-[#FDF3D6] text-black" data-id="element-311" data-mp="30h1i737l5x3a">
      <div className="mx-auto w-full max-w-[1600px] px-6 py-[3.75rem] md:py-[5.25rem] lg:px-12 xl:px-20" data-id="element-312" data-mp="3eg1b4n24sy59">
        <div className="grid gap-8 md:grid-cols-12 md:items-end" data-id="element-313" data-mp="3ag8v5paerppv">
          <div className="md:col-span-6" data-id="element-314" data-mp="1k2jiilmvdb3d">
            <p className="mb-5 text-[0.8125rem] font-semibold uppercase tracking-[0.14em] text-[#005A73]" data-id="element-315" data-mp="1k3l59nd8zm0x">The work behind the opportunity</p>
            <h2 id="work-heading" className="text-4xl font-bold leading-[0.98] tracking-[-0.04em] sm:text-5xl lg:text-7xl" data-id="element-316" data-mp="2zgzyojivjyra">On the ground.<br data-id="element-317" data-mp="34gurism7myez" />Across WA.</h2>
          </div>
          <p className="max-w-lg text-lg leading-8 text-black/75 md:col-span-5 md:col-start-8" data-id="element-318" data-mp="34dgp5kdjqp7j">Big Yellow&apos;s projects run from Norseman through the Goldfields to the Mid-West, including Mt Magnet and Cue.</p>
        </div>

        <div className="mt-14 grid gap-8 md:grid-cols-3" data-id="element-319" data-mp="3j58t707w4gty">
          {projects.map(project => <article key={project.title} className="flex flex-col border-t-4 border-[#D58D33] pt-7" data-id="element-320" data-mp="3n5rnr21640zu">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#005A73]" data-id="element-321" data-mp="3s4vxpuvx22r8">{project.region}</p>
              <h3 className="mt-5 text-2xl font-semibold leading-tight md:text-3xl" data-id="element-322" data-mp="zcjak2izpe1">{project.title}</h3>
              <p className="mt-4 text-base font-medium" data-id="element-323" data-mp="1xsedyxaadkrc">{project.service}</p>
              <p className="mt-auto pt-6 text-sm leading-6 text-black/65" data-id="element-324" data-mp="22pxrtw32nvir">{project.client}</p>
            </article>)}
        </div>

        <p className="mt-10 max-w-4xl text-[0.9375rem] leading-7 text-black/70" data-id="element-325" data-mp="1uq9wquwltqnl">Big Yellow has also worked with Fenix Resources and Genesis Minerals, and on FE Limited&apos;s JWD Iron Ore project in West Wiluna.</p>

        <div className="mt-14 grid gap-6 bg-black p-7 text-white sm:p-10 md:grid-cols-12 md:items-center" data-id="element-326" data-mp="24lutadiwlypy">
          <p className="font-display text-3xl font-bold leading-tight text-[#FFCF53] md:col-span-4 md:text-4xl" data-id="element-327" data-mp="1zr7ex7hm6kp3">Born from gold.</p>
          <p className="text-base leading-7 text-white/85 md:col-span-8 md:text-lg md:leading-8" data-id="element-328" data-mp="29nk69yposmgo">The Big Yellow name comes from the Small Yellow Snake, a historically mined system of gold lodes in Northern Queensland. Founders Dave and Brad set out to find the &ldquo;big yellow snake&rdquo; the old timers talked about. That same strength and resilience still shapes how the company works.</p>
        </div>

        <div className="mt-12 flex flex-col gap-6 border-t border-black/20 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-329" data-mp="2sebbqp6jzsps">
          <div data-id="element-330" data-mp="3bztpilnx20xe">
            <p className="text-xl font-semibold" data-id="element-331" data-mp="3bx7hym10zlf6">Looking for a mining partner?</p>
            <p className="mt-1 text-base text-black/70" data-id="element-332" data-mp="3g0dlhlwr6yhy">Explore our services, equipment and project capability.</p>
          </div>
          <a href="https://bigyellow.au/our-services/" className="btn btn-ghost-dark btn-sm" data-id="element-333" data-mp="323i8xjhamox5">
            Explore our capability <ArrowUpRightIcon aria-hidden="true" size={18} className="btn-icon" data-id="element-334" data-mp="2sbky4du75yyy" />
          </a>
        </div>
      </div>
    </section>;
}